import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__ from "../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__ from "../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Button_variants_js_69bab08d__ from "./Button.variants.js";
function Button({ children, className, disabled, iconLeft, iconRight, loading, buttonType = 'button', ...props }) {
    const { buttonSlot, textSlot, iconSlot } = (0, __WEBPACK_EXTERNAL_MODULE__Button_variants_js_69bab08d__.buttonVariants)({
        ...props,
        disabled: disabled || loading
    });
    const iconSlotClasses = iconSlot();
    const iconSize = 'sm' === props.size ? '20' : '24';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("button", {
        type: buttonType,
        className: (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)(buttonSlot(), className),
        ...(0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cleanProps)(props, [
            'type',
            'shadow',
            'fullWidth'
        ]),
        disabled: disabled || loading,
        "aria-busy": loading,
        children: [
            loading && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)('animate-spin', iconSlotClasses),
                iconName: "refresh",
                size: iconSize
            }),
            iconLeft && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                iconName: iconLeft,
                className: iconSlotClasses,
                size: iconSize
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: textSlot(),
                children: children
            }),
            iconRight && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                iconName: iconRight,
                className: iconSlotClasses,
                size: iconSize
            })
        ]
    });
}
export { Button };
